angular.module("leanlaw.core").factory("snippetService", [function () {
  let _services = {
    addShortCodeHandler,
    getTaskLabel,
    reset
  };

  /**
   * This object keeps track of the last index of short codes that executed.
   * This helps preventing short code execution after it has been
   * undone explicitely by the user.
   * data structure: {shortCOde -> index}
   */
  let lastOriginalDescription = '';
  function addShortCodeHandler(inputId, tasks) {
    lastOriginalDescription = '';
    const descriptionTextArea = document.getElementById(inputId);
    if (!descriptionTextArea) return;
    descriptionTextArea.addEventListener('keydown', event => {
      if (event.key !== ' ') return;
      const descriptionLeftOfCursor = descriptionTextArea.value.substr(0, descriptionTextArea.selectionStart);
      const descriptionRightOfCursor = descriptionTextArea.value.replace(descriptionLeftOfCursor, '');
      const shortCode = descriptionLeftOfCursor.split(' ').pop();
      const isUndone = descriptionLeftOfCursor.toLowerCase() === lastOriginalDescription.toLowerCase();
      if (isUndone) return;
      const task = tasks.find(t => t.shortCode?.toLowerCase() === shortCode.toLowerCase());
      if (!task) return;
      event.preventDefault();
      lastOriginalDescription = descriptionLeftOfCursor;
      descriptionTextArea.focus();
      descriptionTextArea.select();
      const newDescriptionLeftOfCursor = descriptionLeftOfCursor.substr(0, descriptionLeftOfCursor.lastIndexOf(shortCode)) + task.label;
      const newDescription = newDescriptionLeftOfCursor + descriptionRightOfCursor;
      document.execCommand('insertText', false, newDescription);
      // reset cursor position back to where it was before
      descriptionTextArea.setSelectionRange(newDescriptionLeftOfCursor.length, newDescriptionLeftOfCursor.length);
    });
  }
  function getTaskLabel(task) {
    let label = task.label;
    if (task.shortCode) label = `[${task.shortCode}] ${label}`;
    return label;
  }
  function reset() {
    lastOriginalDescription = '';
  }
  return _services;
}]);